import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [utente, setUtente]                         = useState(null);
  const [token, setToken]                           = useState(null);
  const [cambioPasswordObbligatorio, setCambio]     = useState(false);

  const login = useCallback((tok, user, cambio = false) => {
    setToken(tok);
    setUtente(user);
    setCambio(cambio);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUtente(null);
    setCambio(false);
  }, []);

  return (
    <AuthContext.Provider value={{ utente, token, login, logout, isAuth: !!token, cambioPasswordObbligatorio }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
